import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import i18n from "../../i18n";
import Instruction from "./Instruction";
import { Box, Button, CircularProgress, Typography } from "@mui/material";

import { AuthContext } from "../../context/AuthContext";
import { translation_en } from "../../translations/translation_en";
import { translation_hi } from "../../translations/translation_hi";

function ClickLink({ questData }: any) {
  function translate(obj: any, path: string) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

// ✅ Choose translation based on saved language
const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = lang.startsWith("hi") ? translation_hi : translation_en;

// ✅ Define t() function that mimics react-i18next’s syntax
const t = (key: string) => translate(translations, key);
  const [isLoading, setIsLoading] = useState(false);
  const [hasReadInstruction, sethHasReadInstruction] = useState(false);
  const authContext = React.useContext(AuthContext);
  const navigate=useNavigate()
    const steps =
      questData?.data?.subtasks?.map((subtask: any) => ({
        qno: subtask?.question_no,
        qid: subtask?.question_id,
        points: subtask?.points,
        quest: subtask?.question,
        opts: subtask?.options.map((option: any) => option.option_value),
        ans: subtask?.options.find((option: any) => option.correct_option === "1")
          ?.option_value,
        hint: subtask?.hint?.content_type,
      })) || [];
      const encryptedTaskId = window.btoa(questData.data.task_id.toString());
      const storeAnswers = async (data: any) => {
           const tokenn = localStorage.getItem("token");
        const  answerData={
            task_id: questData?.data.task_id,
            question_id: data.qid,
            answer: data.opts,
            no_of_attempts: 1,
            is_correct: true,
          }
        setIsLoading(true);

        return new Promise(async(resolve,reject)=>{
          if (answerData) {
            if (authContext) {
              const { token } = authContext;
              try {
                const response = await fetch(
                  `${process.env.REACT_APP_BASE_URL}/answer/store-answer`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${tokenn}`,
                    'Accept-Language':i18n.language,
                    },
                    body: JSON.stringify([answerData]),
                  }
                );
      
                if (!response.ok) {
                  throw new Error("Failed to store answers");
                }
                setIsLoading(false);
      
                const result = await response.json();
                navigate(`/points/${encryptedTaskId}`);
                console.log("Answers stored successfully:", result);
              } catch (error) {
                setIsLoading(false);
                console.error("Error submitting answer", error);
                reject("Error submitting answer");
              }
            }else{
                setIsLoading(false);
              reject("Error submitting answer");
            }
          }
          resolve("not needed")
        })
      };
    
  return (
    <>
      {isLoading && <div className="loader">Loading...</div>}
      {!hasReadInstruction?
        <Instruction questData={questData} sethHasReadInstruction={(val)=>sethHasReadInstruction(val)}/>
      :
      <>
      {steps.map(({ qno, quest,qid,opts }: any, index: any) => {
        return (
          <Box
            key={qno}
          >
            <Box
                key={index}
                sx={{
                background: "#FFFFFF",
                borderRadius: "12px",
                margin: "10px 10px",
                }}
            >
                <Typography sx={{fontFamily: "Inter",
                paddingLeft:"10px",
                textAlign: "left",
                fontWeight: 600,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "0%"}}>
                    {`${quest}`}
                </Typography>
                </Box>
                <Typography
                    sx={{ fontWeight: 400,
                        fontSize: "18px",
                        lineHeight: "16px",
                        letterSpacing: "-0.5%"}}
                >
                {/* Note: This app is important for upcoming tasks. Thank you! */}
                Note:{t('taskdetaitls.clicklink.note')}
                </Typography>
            <Box 
                 className="foot">
                  <Button
                    className="btn_red"
                    disabled={isLoading}
                    onClick={()=>storeAnswers({qid,opts:opts[0]})}
                  >
                    {t('taskdetaitls.clicklink.quest_submit_btn')}
                    {isLoading ? (
                      <CircularProgress
                        sx={{
                          color: "white",
                          height: "20px !important",
                          width: "20px !important",
                          marginLeft: "8px",
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </Button>
                </Box>
          </Box>
        );
      })
    }
      </>
      }
    </>
  );
}

export default ClickLink;
